// extracted by mini-css-extract-plugin
export default {"footer":"cTF48ZF2gqA+LimLB1SpCA=="};